import { LazyMotion, domAnimation, m } from "framer-motion";
import { uniqBy } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { LazyLoadComponent, trackWindowScroll } from 'react-lazy-load-image-component';

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { Slider } from '../../components';
import { SLIDER } from '../../constants';
import { AdsBannerCard } from './components';

const AdsBannerComponent = React.memo(({ adsData, ybAdsPageData, scrollPosition }) => {
    const [adsProdData, setAdsProdData] = useState([])

    const getProductWithSubHeading = (productBrowseAds = [], product) => {
        return productBrowseAds.reduce((acc, curr) => {
            const productOSRs = curr?.ctaCheck?.productOsr?.split(',')
            const isProductHasEqualOsr = productOSRs.includes(product?.productOsr)

            acc = product
            if (isProductHasEqualOsr) {
                // Subheading received as HTML <p> element placed inside the string
                // in the code below was removed unnecessary tag ang get the content
                const subHeadingContent = curr?.subheading?.slice(3, curr.subheading.length - 4)
                acc.subHeading = subHeadingContent
            }

            return acc
        }, {})
    }

    useEffect(() => {
        if (adsData?.length > 0) {
            const groupOsrs = ybAdsPageData?.ctaCheck?.groupOsr?.split(",")

            groupOsrs?.length > 0 && groupOsrs.map((osrValue) =>
                adsData.map((ProductData) => {
                    if (ProductData.groupOsr === osrValue) {
                        ProductData?.products?.map((productObj) => {
                            const productData = getProductWithSubHeading(ybAdsPageData.ybProductBrowseAds, productObj)

                            setAdsProdData(prevState => uniqBy([...prevState, productData], 'displayName'))
                        }
                        )
                    }
                    return true
                })
            )
        }
    }, [adsData, ybAdsPageData?.ctaCheck?.groupOsr])

    const formattedSliderConfigurationData = useMemo(
        () => adsProdData.map(product => ({ product, ybAdsPageData, scrollPosition })),
        [adsProdData, ybAdsPageData, scrollPosition]
    )

    if (adsProdData?.length > 0) {
        return (
            <LazyMotion features={domAnimation}>
                <LazyLoadComponent scrollPosition={scrollPosition}>
                    <div className="product-categories">
                        <div className="row mb-3 mx-2">
                            <m.div
                                className="container-fluid"
                                variants={SLIDER.CONTAINER}
                                initial="hidden"
                                animate="show"
                            >
                                <LazyLoadComponent>
                                    <Slider
                                        isArrowsHidden
                                        SlideItem={AdsBannerCard}
                                        slidesPerView={1}
                                        slidesPerGroup={1}
                                        slideItemConfigurations={formattedSliderConfigurationData}
                                    />
                                </LazyLoadComponent>
                            </m.div>
                        </div>

                    </div>
                </LazyLoadComponent>
            </LazyMotion>)
    } else {
        return null
    }
})

export default trackWindowScroll(AdsBannerComponent)